(function () {
  // The theme's generic slider-button click handler (SliderComponent, in global.js)
  // scrolls the underlying list — but for the thumbnail / thumbnail_slider gallery
  // layouts, only the .is-active media item is ever visible (every other item is
  // display:none), so there's nothing to scroll to. These prev/next buttons need to
  // advance MediaGallery's active item directly instead.
  function getGallery(button) {
    return button.closest('media-gallery');
  }

  function getOrderedMediaIds(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return [];
    // Scoped to the slide wrappers themselves (.product__media-item), not just any
    // [data-media-id] — product-thumbnail.liquid also stamps that same attribute
    // (unprefixed) on inner zoom/deferred-media elements inside each slide, which
    // would otherwise double-count every image and throw off the step math.
    return Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]')).map((el) => el.dataset.mediaId);
  }

  function step(gallery, direction, buttonsWrapper) {
    const ids = getOrderedMediaIds(gallery);
    if (ids.length < 2) return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const activeEl =
      viewer.querySelector('.product__media-item.is-active[data-media-id]') ||
      viewer.querySelector('.product__media-item[data-media-id]');
    const currentIndex = ids.indexOf(activeEl.dataset.mediaId);
    const nextIndex = (currentIndex + direction + ids.length) % ids.length;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(ids[nextIndex], false);
    }

    // Toggling .is-active changes which single media item is display:none vs not,
    // which changes the underlying <ul>'s rendered size — which wakes the slider's
    // own ResizeObserver (SliderComponent, in global.js) a moment later. Its update()
    // recomputes the counter from scroll position (always "page 1" here, since
    // nothing actually scrolls in this layout) and can disable these very buttons
    // based on scroll-visibility logic that doesn't apply. Reassert our state right
    // after, once that settles.
    const applyCount = () => {
      const counter = buttonsWrapper.querySelector('.slider-counter--current');
      if (counter) counter.textContent = nextIndex + 1;
      const prevBtn = buttonsWrapper.querySelector('.slider-button--prev');
      const nextBtn = buttonsWrapper.querySelector('.slider-button--next');
      if (prevBtn) prevBtn.removeAttribute('disabled');
      if (nextBtn) nextBtn.removeAttribute('disabled');
    };
    applyCount();
    setTimeout(applyCount, 60);
  }

  // Capture phase, on document: runs before SliderComponent's own click listener
  // (attached directly on this same button in global.js), whose scroll-based
  // onButtonClick fights with setActiveMedia and leaves .is-active cleared. Stopping
  // propagation here keeps that handler from ever running for these two buttons.
  document.addEventListener(
    'click',
    (event) => {
      const nextButton = event.target.closest('media-gallery .slider-button--next');
      const prevButton = event.target.closest('media-gallery .slider-button--prev');
      const button = nextButton || prevButton;
      if (!button) return;

      const gallery = getGallery(button);
      const buttonsWrapper = button.closest('.slider-buttons');
      if (!gallery || !buttonsWrapper) return;

      event.stopPropagation();
      step(gallery, nextButton ? 1 : -1, buttonsWrapper);
    },
    true
  );
})();
